import { render, staticRenderFns } from "./carpsalePreviewComponent.vue?vue&type=template&id=833d7cd6&"
import script from "./carpsalePreviewComponent.vue?vue&type=script&lang=ts&"
export * from "./carpsalePreviewComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports